/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react'

const toBase64ImgString = base64 => `data:image/png;base64, ${base64}`

export const Img = ({ isBase64, src, ...rest }) => !isBase64 ? <img {...rest} src={src} />
  : <img {...rest} src={toBase64ImgString(src)} />
